import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import { useSelector, useDispatch, connect } from 'react-redux';
import { Link } from 'react-router-dom';
import moment from 'moment';

import {
  updateVersion, showPublishedDateUpdate, hidePublishedDateUpdate
} from 'actions';
import LoadingWrapper from 'components/Common/LoadingWrapper';
import PublishedVersionsUpdateModal from 'components/Modals/PublishedVersionsUpdateModal';

const WhdStatementVersions = ({ accountId, getVersionsCallback, refreshVersions }) => {
  const { statementVersions, isLoadingStatementVersions, isShowingPublishedVersionsUpdate } = useSelector(state => state && state.forms);

  const [currentPage, setCurrentPage] = useState(1);

  const getDate = date => moment(date).format('MMM DD, YYYY');
  const isLatestStatement = index => index === 0;

  const dispatch = useDispatch();

  const changePage = (pageNumber) => {
    if (pageNumber <= 0) {
      return;
    }
    setCurrentPage(pageNumber);
    getVersionsCallback(accountId, pageNumber);
  };

  const versionWindows = statementVersions?.versions?.map(({ effectiveFrom, effectiveTo, index, version }) => ({ effectiveFrom, effectiveTo, index, version }));

  const getPageNavigation = (totalItems, currentPageSize) => {
    const remainder = totalItems % currentPageSize;
    const pageCount = Math.trunc(totalItems / currentPageSize) + ((remainder > 0) ? 1 : 0);

    return <div className="whs-version-navigation">
      <button className="btn btn-secondary" type="button" disabled={ currentPage <= 1 } onClick={ () => changePage(currentPage - 1) }>Previous</button>
      <h3>{ pageCount > 0 ? `Page ${ currentPage } of ${ pageCount }` : 'Page 1 of 1' }</h3>
      <button className="btn btn-secondary" type="button" disabled={ currentPage >= pageCount } onClick={ () => changePage(currentPage + 1) }>Next</button>
    </div>;
  };

  const toggleDescription = (element) => {
    if (element.className.indexOf(' active') === -1) {
      element.className += ' active';
    } else {
      element.className = element.className.replace(' active', '');
    }
  };

  const onConfirmUpdatedDate = (index, version) => {
    dispatch(showPublishedDateUpdate(index, version));
  };

  const onUpdateStatement = (versionWindow) => {
    dispatch(updateVersion(accountId, versionWindow));
    dispatch(hidePublishedDateUpdate());
  };

  const onCancelUpdateStatement = () => {
    dispatch(hidePublishedDateUpdate());
  };

  useEffect(() => {
    if (refreshVersions) {
      changePage(currentPage);
    }
  }, [refreshVersions]);

  return (
    <div className="whs-versions">
      <LoadingWrapper loaded={ !isLoadingStatementVersions } />
      { !isLoadingStatementVersions && <div className="whs-versions-list clearfix">
        { !isLoadingStatementVersions && (!statementVersions?.versions || statementVersions.versions.length === 0) && <h2 className="text-center">No Published Versions</h2> }
        { statementVersions?.versions && statementVersions.versions.length > 0 && <React.Fragment><React.Fragment>
          <h2>Published Versions</h2>
          {statementVersions.versions.map((version, index) => (
            <div key={ `version_${ index + 1 }` } className="whs-version">
              <div className="columns pb-2 m-0">
                <div className="col-8 col-xl-12">
                  <div>Name: {version?.data?.name ?? 'N/A'}</div>
                  <div>Effective: {getDate(version.effectiveFrom)}{version?.effectiveTo && ` - ${ getDate(version.effectiveTo) }`}
                    {isLatestStatement(index) && currentPage === 1 && ' (Latest)'}
                  </div>
                  <div>Validity: {version.isValid ? <span className="valid-text">Valid</span> : <span className="invalid-text">Invalid</span>}</div>
                  <div aria-hidden="true" onClick={ e => toggleDescription(e.target) }>
                    <span className="text-ellipsis text-expander">Description: { version?.data?.description ?? 'N/A' }</span>
                  </div>
                  <div>User: { version.username }</div>
                </div>
                <div className="col-4 col-xl-12 text-right">
                  <div className="columns">
                    <div className="col-12 col-xl-6 d-inline-block">
                      <button
                        className="btn btn-secondary whs-version btn-edit m-1"
                        type="button"
                        onClick={ () => onConfirmUpdatedDate(index, version.version) }
                      > <span className="ag-icon-tick" /><i className="icon icon-2x icon-edit mr-2" />
                        Edit Dates
                      </button>
                      <Link className="btn btn-secondary m-1" to={ `/whd-statement/${ accountId }/${ version.version }` }>View</Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </React.Fragment><React.Fragment>
          {isShowingPublishedVersionsUpdate && <PublishedVersionsUpdateModal
            key="publishedVersionsUpdateModal"
            isShown={ isShowingPublishedVersionsUpdate }
            onConfirm={ versionWindow => onUpdateStatement(versionWindow) }
            onCancel={ () => onCancelUpdateStatement() }
            title="Update Statement"
            confirmTitle="Confirm Effective Date and Update Statement"
            versionWindows={ versionWindows }
          />}
        </React.Fragment></React.Fragment> }
        { statementVersions?.versions && statementVersions.versions.length > 0 && <div>{ getPageNavigation(statementVersions.totalCount, 10) }</div> }
      </div> }
    </div>
  );
};

WhdStatementVersions.propTypes = {
  accountId: PropTypes.number.isRequired,
  getVersionsCallback: PropTypes.func.isRequired,
  refreshVersions: PropTypes.bool
};

WhdStatementVersions.defaultProps = {
  refreshVersions: false
};

function mapStateToProps(state) {
  const {
    forms: {
      refreshVersions
    }
  } = state;
  return {
    refreshVersions
  };
}
export default connect(
  mapStateToProps,
  null
)(WhdStatementVersions);
